import { FunctionComponent, PropsWithChildren } from "react"
import styles from "./styles.module.scss"

const ErrorMessage: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <p className={styles.error}>{children}</p>
}

export default ErrorMessage
